import React from 'react';
import './playlist.scss';

export default class Playlist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playlist: props.playlist || {},
      showDetails: props.showDetails || false,
      hasFocus: props.hasFocus || false,
    };
    this._handleClick = props.handleClick;
    this.count = localStorage.getItem('Count');
    if (this.count != null && this.count < 37) {
      this.count = parseInt(this.count) + 1;
      localStorage.setItem('Count', this.count);
    } else {
      localStorage.setItem('Count', 0);
    }

    this.sendCount = this.sendCount.bind(this);
  }

  componentWillReceiveProps({ showDetails, playlist, hasFocus }) {
    this.setState({ showDetails, playlist, hasFocus });
  }

  sendCount(count) {
    if (typeof this._handleClick === 'function') {
      this._handleClick(count);
    }
  }

  render() {
    const { playlist } = this.props;
    return (
      <div className="playlist" style={this.state.showDetails ? { border: '6px solid #910048' } : null}>
        {playlist.location ? null : <div className="playlistName">{playlist.name}</div>}
        <img
          count={this.count}
          className="image"
          src={playlist.img ? playlist.img.image.high : playlist.media.images.thumbnail}
        />
      </div>
    );
  }
}
